import SecureComponent from '@app/components/SecureComponent'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { Link, NavLink, RouteComponentProps } from 'react-router-dom'
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
} from 'reactstrap'
import './Sidebar.scss'

interface IComponentProps {
  closeSidebar: () => void
}

interface IComponentState {
  administrationDropdownOpen: boolean
  brokerageDropdownOpen: boolean
  calendarDropdownOpen: boolean
  developmentDropdownOpen: boolean
  personalDropdownOpen: boolean
  propertiesDropdownOpen: boolean
  reportDropdownOpen: boolean
  selectedDropdown: string
  selectedLink: string
}

type SidebarProps = IComponentProps & RouteComponentProps<{}>

export default class Sidebar extends React.PureComponent<
  SidebarProps,
  IComponentState
> {
  constructor(props: any) {
    super(props)

    bindFunctions(this)

    this.state = {
      administrationDropdownOpen: false,
      brokerageDropdownOpen: false,
      calendarDropdownOpen: false,
      developmentDropdownOpen: false,
      personalDropdownOpen: false,
      propertiesDropdownOpen: false,
      reportDropdownOpen: false,
      selectedDropdown: '',
      selectedLink: '',
    }
  }

  public render() {
    return (
      <div className='sidebarContent'>
        <div className='text-center'>
          <img
            src='/images/HB_Logo_Square_150.png'
            style={{ marginTop: '20px', marginBottom: '20px' }}
          />
        </div>
        <div className='sidebarList'>
          <Nav navbar>
            <SecureComponent brokerage development>
              <NavItem>
                <NavLink
                  exact
                  to={'/home'}
                  className={`nav-link`}
                  activeClassName='active'
                  onClick={() => {
                    this._itemSelected('home')
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'home']} fixedWidth /> HOME
                </NavLink>
              </NavItem>
            </SecureComponent>
            <SecureComponent brokerage development>
              <NavItem>
                <NavLink
                  to={'/chat'}
                  activeClassName='active'
                  className={`nav-link`}
                  onClick={() => {
                    this._itemSelected('chat')
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'messages']} fixedWidth />{' '}
                  CHAT
                </NavLink>
              </NavItem>
            </SecureComponent>
            <SecureComponent brokerage development>
              <NavItem>
                <NavLink
                  to={'/connections'}
                  activeClassName='active'
                  className={`nav-link`}
                  onClick={() => {
                    this._itemSelected('connections')
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'user-friends']} fixedWidth />{' '}
                  CONNECTIONS
                </NavLink>
              </NavItem>
            </SecureComponent>
            <SecureComponent brokerage>
              <Dropdown
                isOpen={this.state.propertiesDropdownOpen}
                className={this._setActive('properties')}
                toggle={() => false}
                onClick={this._toggle.bind(this, 'properties')}
                nav
                inNavbar
              >
                <DropdownToggle nav caret>
                  <FontAwesomeIcon icon={['fal', 'university']} fixedWidth />{' '}
                  PROPERTIES
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem toggle={false}>
                    <Link
                      to={'/properties/properties'}
                      className={`${
                        this.state.selectedLink === 'properties' ? 'active' : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('properties')
                      }}
                    >
                      <div>PROPERTIES</div>
                    </Link>
                  </DropdownItem>
                  <DropdownItem toggle={false}>
                    <Link
                      to={'/properties/successStories'}
                      className={`${
                        this.state.selectedLink === 'successStories'
                          ? 'active'
                          : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('successStories')
                      }}
                    >
                      <div>SUCCESS STORIES</div>
                    </Link>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </SecureComponent>
            <SecureComponent brokerage>
              <Dropdown
                isOpen={this.state.brokerageDropdownOpen}
                className={this._setActive('brokerage')}
                toggle={() => false}
                onClick={this._toggle.bind(this, 'brokerage')}
                nav
                inNavbar
              >
                <DropdownToggle nav caret>
                  <FontAwesomeIcon icon={['fal', 'piggy-bank']} fixedWidth />{' '}
                  BROKERAGE
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem toggle={false}>
                    <Link
                      to='/brokerage/leads'
                      className={`${
                        this.state.selectedLink === 'leads' ? 'active' : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('leads')
                      }}
                    >
                      <div>LEADS</div>
                    </Link>
                  </DropdownItem>
                  <DropdownItem toggle={false}>
                    <Link
                      to='/brokerage/listings'
                      className={`${
                        this.state.selectedLink === 'listings' ? 'active' : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('listings')
                      }}
                    >
                      <div>LISTINGS</div>
                    </Link>
                  </DropdownItem>
                  <DropdownItem toggle={false}>
                    <Link
                      to='/brokerage/pipeline'
                      className={`${
                        this.state.selectedLink === 'pipeline' ? 'active' : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('pipeline')
                      }}
                    >
                      <div>PIPELINE</div>
                    </Link>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </SecureComponent>
            <SecureComponent development guest>
              <Dropdown
                isOpen={this.state.developmentDropdownOpen}
                className={this._setActive('development')}
                toggle={() => false}
                onClick={this._toggle.bind(this, 'development')}
                nav
                inNavbar
              >
                <DropdownToggle nav caret>
                  <FontAwesomeIcon icon={['fal', 'sign']} fixedWidth />{' '}
                  DEVELOPMENT
                </DropdownToggle>
                <DropdownMenu right>
                  <SecureComponent development>
                    <DropdownItem toggle={false}>
                      <Link
                        to='/development/cities'
                        className={`${
                          this.state.selectedLink === 'cities' ? 'active' : ''
                        }`}
                        onClick={(e) => {
                          this._itemSelected('cities')
                        }}
                      >
                        <div>CITIES</div>
                      </Link>
                    </DropdownItem>
                  </SecureComponent>
                  <DropdownItem toggle={false}>
                    <Link
                      to='/development/clients'
                      className={`${
                        this.state.selectedLink === 'clients' ? 'active' : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('clients')
                      }}
                    >
                      <div>CLIENTS</div>
                    </Link>
                  </DropdownItem>
                  <DropdownItem toggle={false}>
                    <Link
                      to='/development/myProjects'
                      className={`${
                        this.state.selectedLink === 'projects' ? 'active' : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('projects')
                      }}
                    >
                      <div>MY PROJECTS</div>
                    </Link>
                  </DropdownItem>
                  <SecureComponent development>
                    <DropdownItem toggle={false}>
                      <Link
                        to='/development/earnestMoney'
                        className={`${
                          this.state.selectedLink === 'earnestMoney'
                            ? 'active'
                            : ''
                        }`}
                        onClick={(e) => {
                          this._itemSelected('earnestMoney')
                        }}
                      >
                        <div>EARNEST MONEY</div>
                      </Link>
                    </DropdownItem>
                  </SecureComponent>
                </DropdownMenu>
              </Dropdown>
            </SecureComponent>
            <Dropdown
              isOpen={this.state.personalDropdownOpen}
              className={this._setActive('personal')}
              toggle={() => false}
              onClick={this._toggle.bind(this, 'personal')}
              nav
              inNavbar
            >
              <DropdownToggle nav caret>
                <FontAwesomeIcon icon={['fal', 'user-secret']} fixedWidth />{' '}
                PERSONAL
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem toggle={false}>
                  <Link
                    to='/assignments'
                    className={`${
                      this.state.selectedLink === 'assignments' ? 'active' : ''
                    }`}
                    onClick={(e) => {
                      this._itemSelected('assignments')
                    }}
                  >
                    <div>ASSIGNMENTS</div>
                  </Link>
                </DropdownItem>
                <SecureComponent brokerage development>
                  <DropdownItem toggle={false} style={{ display: 'none' }}>
                    <Link
                      to='/todos'
                      className={`${
                        this.state.selectedLink === 'todos' ? 'active' : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('todos')
                      }}
                    >
                      <div>TO DOS</div>
                    </Link>
                  </DropdownItem>
                  <DropdownItem toggle={false} style={{ display: 'none' }}>
                    <Link
                      to='/messages'
                      className={`${
                        this.state.selectedLink === 'messages' ? 'active' : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('messages')
                      }}
                    >
                      <div>MESSAGES</div>
                    </Link>
                  </DropdownItem>
                  <DropdownItem toggle={false} style={{ display: 'none' }}>
                    <Link
                      to='/goals'
                      className={`${
                        this.state.selectedLink === 'goals' ? 'active' : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('goals')
                      }}
                    >
                      <div>GOALS</div>
                    </Link>
                  </DropdownItem>
                </SecureComponent>
              </DropdownMenu>
            </Dropdown>
            <Dropdown
              isOpen={this.state.calendarDropdownOpen}
              className={this._setActive('calendar')}
              toggle={() => false}
              onClick={this._toggle.bind(this, 'calendar')}
              nav
              inNavbar
            >
              <DropdownToggle nav caret>
                <FontAwesomeIcon icon={['fal', 'calendar']} fixedWidth />{' '}
                CALENDARS
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem toggle={false}>
                  <Link
                    to='/calendars/Assignments'
                    className={`${
                      this.state.selectedLink === 'assignmentsCalendar'
                        ? 'active'
                        : ''
                    }`}
                    onClick={(e) => {
                      this._itemSelected('assignmentsCalendar')
                    }}
                  >
                    <div>ASSIGNMENTS</div>
                  </Link>
                </DropdownItem>
                <SecureComponent development guest>
                  <DropdownItem toggle={false}>
                    <Link
                      to='/calendars/DueDiligence'
                      className={`${
                        this.state.selectedLink === 'duediligenceCalendar'
                          ? 'active'
                          : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('duediligenceCalendar')
                      }}
                    >
                      <div>DUE DILIGENCE</div>
                    </Link>
                  </DropdownItem>
                </SecureComponent>
                <SecureComponent brokerage>
                  <DropdownItem toggle={false}>
                    <Link
                      to='/calendars/BrokeragePipelines'
                      className={`${
                        this.state.selectedLink === 'pipelineCalendar'
                          ? 'active'
                          : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('pipelineCalendar')
                      }}
                    >
                      <div>PIPELINE</div>
                    </Link>
                  </DropdownItem>
                  <DropdownItem toggle={false}>
                    <Link
                      to='/calendars/Listings'
                      className={`${
                        this.state.selectedLink === 'listingsCalendar'
                          ? 'active'
                          : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('listingsCalendar')
                      }}
                    >
                      <div>LISTINGS</div>
                    </Link>
                  </DropdownItem>
                </SecureComponent>
              </DropdownMenu>
            </Dropdown>
            <SecureComponent brokerage development>
              <NavItem>
                <NavLink
                  to={'/forms'}
                  className='nav-link'
                  activeClassName='active'
                  onClick={() => {
                    this._itemSelected('forms')
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'list']} fixedWidth /> FORMS
                </NavLink>
              </NavItem>
            </SecureComponent>
            <SecureComponent brokerage>
              <Dropdown
                isOpen={this.state.reportDropdownOpen}
                className={this._setActive('reports')}
                toggle={() => false}
                onClick={this._toggle.bind(this, 'reports')}
                nav
                inNavbar
              >
                <DropdownToggle nav caret>
                  <FontAwesomeIcon icon={['fal', 'chart-bar']} fixedWidth />{' '}
                  REPORTS
                </DropdownToggle>
                <DropdownMenu right>
                  <SecureComponent>
                    <DropdownItem toggle={false}>
                      <Link
                        to='/admin/reports/earnings'
                        className={`${
                          this.state.selectedLink === 'earnings' ? 'active' : ''
                        }`}
                        onClick={(e) => {
                          this._itemSelected('earnings')
                        }}
                      >
                        <div>EARNINGS</div>
                      </Link>
                    </DropdownItem>
                  </SecureComponent>
                  <SecureComponent>
                    <DropdownItem toggle={false}>
                      <Link
                        to='/admin/reports/earnestMoney'
                        className={`${
                          this.state.selectedLink === 'earnestMoneyReport'
                            ? 'active'
                            : ''
                        }`}
                        onClick={(e) => {
                          this._itemSelected('earnestMoneyReport')
                        }}
                      >
                        <div>EARNEST MONEY</div>
                      </Link>
                    </DropdownItem>
                  </SecureComponent>
                  <SecureComponent>
                    <DropdownItem toggle={false}>
                      <Link
                        to='/admin/reports/potentialProfit'
                        className={`${
                          this.state.selectedLink === 'projectedProfit'
                            ? 'active'
                            : ''
                        }`}
                        onClick={(e) => {
                          this._itemSelected('projectedProfit')
                        }}
                      >
                        <div>PROJECTED PROFIT</div>
                      </Link>
                    </DropdownItem>
                  </SecureComponent>
                  <DropdownItem toggle={false}>
                    <Link
                      to='/admin/reports/signs'
                      className={`${
                        this.state.selectedLink === 'signs' ? 'active' : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('signs')
                      }}
                    >
                      <div>SIGNS</div>
                    </Link>
                  </DropdownItem>
                  <DropdownItem>
                    <Link
                      to='/admin/reports/soldProperties'
                      className={`${
                        this.state.selectedLink === 'soldProperties'
                          ? 'active'
                          : ''
                      }`}
                      onClick={() => this._itemSelected('soldProperties')}
                    >
                      <div>SOLD PROPERTIES</div>
                    </Link>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </SecureComponent>
            <SecureComponent brokerage development>
              <NavItem>
                <NavLink
                  to={'/tutorials'}
                  activeClassName='active'
                  className={`nav-link`}
                  onClick={() => {
                    this._itemSelected('tutorials')
                  }}
                >
                  <FontAwesomeIcon icon={['fal', 'video']} fixedWidth />{' '}
                  TUTORIALS
                </NavLink>
              </NavItem>
            </SecureComponent>
            <SecureComponent>
              <Dropdown
                isOpen={this.state.administrationDropdownOpen}
                className={this._setActive('admin')}
                toggle={() => false}
                onClick={this._toggle.bind(this, 'admin')}
                nav
                inNavbar
              >
                <DropdownToggle nav caret>
                  <FontAwesomeIcon icon={['fal', 'user-shield']} fixedWidth />{' '}
                  ADMINISTRATION
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem toggle={false}>
                    <Link
                      to='/admin/teams'
                      className={`${
                        this.state.selectedLink === 'teams' ? 'active' : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('teams')
                      }}
                    >
                      <div>TEAMS</div>
                    </Link>
                  </DropdownItem>
                  <DropdownItem toggle={false}>
                    <Link
                      to='/admin/users'
                      className={`${
                        this.state.selectedLink === 'users' ? 'active' : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('users')
                      }}
                    >
                      <div>USERS</div>
                    </Link>
                  </DropdownItem>
                  <DropdownItem toggle={false}>
                    <Link
                      to='/admin/guests'
                      className={`${
                        this.state.selectedLink === 'guests' ? 'active' : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('guests')
                      }}
                    >
                      <div>GUESTS</div>
                    </Link>
                  </DropdownItem>
                  <DropdownItem toggle={false}>
                    <Link
                      to='/admin/mergeConnections'
                      className={`${
                        this.state.selectedLink === 'merge' ? 'active' : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('merge')
                      }}
                    >
                      <div>MERGE CONNECTIONS</div>
                    </Link>
                  </DropdownItem>
                  <DropdownItem toggle={false}>
                    <Link
                      to='/admin/manageSignTypes'
                      className={`${
                        this.state.selectedLink === 'signTypes' ? 'active' : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('signTypes')
                      }}
                    >
                      <div>SIGN TYPES</div>
                    </Link>
                  </DropdownItem>
                  <DropdownItem toggle={false}>
                    <Link
                      to='/admin/settings'
                      className={`${
                        this.state.selectedLink === 'settings' ? 'active' : ''
                      }`}
                      onClick={(e) => {
                        this._itemSelected('settings')
                      }}
                    >
                      <div>SITE SETTINGS</div>
                    </Link>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </SecureComponent>
          </Nav>
        </div>
      </div>
    )
  }

  private _toggle(dropdown: string) {
    switch (dropdown) {
      case 'properties':
        this.setState((prevState) => ({
          propertiesDropdownOpen: !prevState.propertiesDropdownOpen,
        }))
        break
      case 'brokerage':
        this.setState((prevState) => ({
          brokerageDropdownOpen: !prevState.brokerageDropdownOpen,
        }))
        break
      case 'development':
        this.setState((prevState) => ({
          developmentDropdownOpen: !prevState.developmentDropdownOpen,
        }))
        break
      case 'personal':
        this.setState((prevState) => ({
          personalDropdownOpen: !prevState.personalDropdownOpen,
        }))
        break
      case 'calendar':
        this.setState((prevState) => ({
          calendarDropdownOpen: !prevState.calendarDropdownOpen,
        }))
        break
      case 'reports':
        this.setState((prevState) => ({
          reportDropdownOpen: !prevState.reportDropdownOpen,
        }))
        break
      case 'admin':
        this.setState((prevState) => ({
          administrationDropdownOpen: !prevState.administrationDropdownOpen,
        }))
        break
      default:
        break
    }
  }

  private _setActive(dropdown: string) {
    switch (dropdown) {
      case 'properties':
        return this.state.selectedLink === 'properties' ||
          this.state.selectedLink === 'successStories'
          ? 'activeDropdown'
          : ''
      case 'brokerage':
        return this.state.selectedLink === 'leads' ||
          this.state.selectedLink === 'listings' ||
          this.state.selectedLink === 'pipeline'
          ? 'activeDropdown'
          : ''
      case 'development':
        return this.state.selectedLink === 'cities' ||
          this.state.selectedLink === 'clients' ||
          this.state.selectedLink === 'projects' ||
          this.state.selectedLink === 'earnestMoney'
          ? 'activeDropdown'
          : ''
      case 'personal':
        return this.state.selectedLink === 'assignments' ||
          this.state.selectedLink === 'todos' ||
          this.state.selectedLink === 'messages' ||
          this.state.selectedLink === 'goals'
          ? 'activeDropdown'
          : ''
      case 'calendar':
        return this.state.selectedLink === 'myassignments' ||
          this.state.selectedLink === 'duediligence' ||
          this.state.selectedLink === 'mypipeline' ||
          this.state.selectedLink === 'mylistings'
          ? 'activeDropdown'
          : ''
      case 'reports':
        return this.state.selectedLink === 'earnings' ||
          this.state.selectedLink === 'earnestMoneyReport' ||
          this.state.selectedLink === 'projectedProfit' ||
          this.state.selectedLink === 'signs'
          ? 'activeDropdown'
          : ''
      case 'admin':
        return this.state.selectedLink === 'teams' ||
          this.state.selectedLink === 'users' ||
          this.state.selectedLink === 'guests' ||
          this.state.selectedLink === 'merge' ||
          this.state.selectedLink === 'signTypes' ||
          this.state.selectedLink === 'settings'
          ? 'activeDropdown'
          : ''
      default:
        break
    }

    return ''
  }

  private _itemSelected(link: string) {
    this.setState({
      administrationDropdownOpen: false,
      brokerageDropdownOpen: false,
      calendarDropdownOpen: false,
      developmentDropdownOpen: false,
      personalDropdownOpen: false,
      propertiesDropdownOpen: false,
      reportDropdownOpen: false,
      selectedLink: link,
    })

    this.props.closeSidebar()
  }
}
